// スムーススクロール リンク

const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');

for (let i = 0; i < smoothScrollTrigger.length; i++){
  smoothScrollTrigger[i].addEventListener('click', (e) => {
    e.preventDefault();
    let href = smoothScrollTrigger[i].getAttribute('href');
    let targetElement = document.getElementById(href.replace('#', ''));
    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.scrollY;
    const target = rect + offset;

    window.scrollTo({
      top: target,
      behavior: 'smooth',
    });
  });
}

//pageTop

const pagetop = () => {
  const pagetopButton = document.querySelector('.pagetop');

  pagetopButton.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
};

pagetop();